// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyD4_kHotTFEKfZCjMNDRoHmv2Xvi8lC8w0",
    authDomain: "figtionary2.firebaseapp.com",
    databaseURL: "https://figtionary2.firebaseio.com",
    projectId: "figtionary2",
    storageBucket: "figtionary2.appspot.com",
    messagingSenderId: "129310518335",
    appId: "1:129310518335:web:3432fad0224794e5"
  }

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
